import { render, staticRenderFns } from "./EventLocationsPage.vue?vue&type=template&id=c0929328&"
import script from "./EventLocationsPage.vue?vue&type=script&lang=js&"
export * from "./EventLocationsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports